import { PreventBrowserScroll } from "@homebound/beam";
import { Outlet } from "react-router-dom";
import { GlobalNav } from "src/routes/layout/GlobalNav";
import { LoggedInPageWrapper } from "src/routes/layout/LoggedInPageWrapper";

/**
 * Global nav + logged-in page wrapper above the matched child route.
 *
 * Role: data router pathless layout. Nest under a domain `RouteObject` in `src/routing/domains/*.ts`.
 * See DESIGN.md "Chrome wrappers".
 *
 * `PreventBrowserScroll` lives here (not in `AuthenticatedShell`) so sibling layout routes
 * (e.g. a future Beam `NavbarLayout`) can use different scroll behavior.
 */
export function GlobalNavLayout() {
  return (
    <PreventBrowserScroll>
      <GlobalNav />
      <LoggedInPageWrapper>
        <Outlet />
      </LoggedInPageWrapper>
    </PreventBrowserScroll>
  );
}
